import barcodes from "./barcodes/";
import merge from "./help/merge.js";
import linearizeEncodings from "./help/linearizeEncodings.js";
import fixOptions from "./help/fixOptions.js";
import getRenderProperties from "./help/getRenderProperties.js";
import optionsFromStrings from "./help/optionsFromStrings.js";
import ErrorHandler from "./exceptions/ErrorHandler.js";
import { InvalidInputException, NoElementException } from "./exceptions/exceptions.js";
import defaults from "./options/defaults.js";
let API = function() {
};
let JsBarcode = function(element, text, options) {
  var api = new API();
  if (typeof element === "undefined") {
    throw Error("No element to render on was provided.");
  }
  api._renderProperties = getRenderProperties(element);
  api._encodings = [];
  api._options = defaults;
  api._errorHandler = new ErrorHandler(api);
  if (typeof text !== "undefined") {
    options = options || {};
    if (!options.format) {
      options.format = autoSelectBarcode();
    }
    api.options(options)[options.format](text, options).render();
  }
  return api;
};
JsBarcode.getModule = function(name) {
  return barcodes[name];
};
for (var name in barcodes) {
  if (barcodes.hasOwnProperty(name)) {
    registerBarcode(barcodes, name);
  }
}
function registerBarcode(barcodes2, name) {
  API.prototype[name] = API.prototype[name.toUpperCase()] = API.prototype[name.toLowerCase()] = function(text, options) {
    var api = this;
    return api._errorHandler.wrapBarcodeCall(function() {
      options.text = typeof options.text === "undefined" ? void 0 : "" + options.text;
      var newOptions = merge(api._options, options);
      newOptions = optionsFromStrings(newOptions);
      var Encoder = barcodes2[name];
      var encoded = encode(text, Encoder, newOptions);
      api._encodings.push(encoded);
      return api;
    });
  };
}
function encode(text, Encoder, options) {
  text = "" + text;
  var encoder = new Encoder(text, options);
  if (!encoder.valid()) {
    throw new InvalidInputException(encoder.constructor.name, text);
  }
  var encoded = encoder.encode();
  encoded = linearizeEncodings(encoded);
  for (let i = 0; i < encoded.length; i++) {
    encoded[i].options = merge(options, encoded[i].options);
  }
  return encoded;
}
function autoSelectBarcode() {
  if (barcodes["CODE128"]) {
    return "CODE128";
  }
  return Object.keys(barcodes)[0];
}
API.prototype.options = function(options) {
  this._options = merge(this._options, options);
  return this;
};
API.prototype.blank = function(size) {
  const zeroes = new Array(size + 1).join("0");
  this._encodings.push({ data: zeroes });
  return this;
};
API.prototype.init = function() {
  if (!this._renderProperties) {
    return;
  }
  if (!Array.isArray(this._renderProperties)) {
    this._renderProperties = [this._renderProperties];
  }
  var renderProperty;
  for (let i in this._renderProperties) {
    renderProperty = this._renderProperties[i];
    var options = merge(this._options, renderProperty.options);
    if (options.format == "auto") {
      options.format = autoSelectBarcode();
    }
    this._errorHandler.wrapBarcodeCall(function() {
      var text = options.value;
      var Encoder = barcodes[options.format.toUpperCase()];
      var encoded = encode(text, Encoder, options);
      render(renderProperty, encoded, options);
    });
  }
};
API.prototype.render = function() {
  if (!this._renderProperties) {
    throw new NoElementException();
  }
  if (Array.isArray(this._renderProperties)) {
    for (var i = 0; i < this._renderProperties.length; i++) {
      render(this._renderProperties[i], this._encodings, this._options);
    }
  } else {
    render(this._renderProperties, this._encodings, this._options);
  }
  return this;
};
API.prototype._defaults = defaults;
function render(renderProperties, encodings, options) {
  encodings = linearizeEncodings(encodings);
  for (let i = 0; i < encodings.length; i++) {
    encodings[i].options = merge(options, encodings[i].options);
    fixOptions(encodings[i].options);
  }
  fixOptions(options);
  var Renderer = renderProperties.renderer;
  var renderer = new Renderer(renderProperties.element, encodings, options);
  renderer.render();
  if (renderProperties.afterRender) {
    renderProperties.afterRender();
  }
}
if (typeof window !== "undefined") {
  window.JsBarcode = JsBarcode;
}
if (typeof hiprintJQuery !== "undefined") {
  hiprintJQuery.fn.JsBarcode = function(content, options) {
    var elementArray = [];
    hiprintJQuery(this).each(function() {
      elementArray.push(this);
    });
    return JsBarcode(elementArray, content, options);
  };
}
var stdin_default = JsBarcode;
export {
  stdin_default as default
};
